import { TFunction } from "i18next";
import { PositionOption, StagePosition } from "./types";

export const getStagePositionOptions = <
  T extends { id: string | number; name: string }
>(
  stages: T[],
  t: TFunction<"translation", undefined>,
  tPrefix: string,
  currentStage?: T
): PositionOption[] => {
  const options: PositionOption[] = [
    {
      id: StagePosition.FIRST as string,
      displayName: t(`${tPrefix}.firstStage`)
    }
  ];

  stages
    .filter((stage) => !currentStage || stage.id !== currentStage.id)
    .forEach((stage) =>
      options.push({
        id: `${StagePosition.AFTER_PREFIX}${stage.id}`,
        displayName: t(`${tPrefix}.afterStage`, { stageName: stage.name })
      })
    );

  options.push({
    id: StagePosition.LAST,
    displayName: t(`${tPrefix}.lastStage`)
  });
  return options;
};
